import { Component, inject, OnInit, signal } from '@angular/core';

import { GridOptions, GridEmitter, UiGridComponent } from '@program-suite/ui-grid';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '@program-suite/ui';
import { Sort } from '@angular/material/sort';
import { LookupStore, SubmissionGridStore,
  SubmissionGridRowViewModel,
  SubmissionGridOptions,
  InAppNotificationsService
} from '@program-suite/data-common';
import { AuthStore } from '@program-suite/data-auth';
import { Router } from '@angular/router';
import { InAppNotificationModalComponent } from '@program-suite/ui';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'lib-submission-grid',
  imports: [UiGridComponent, MatMenuModule, MatButtonModule],
  templateUrl: './submission-grid.component.html',
  styleUrl: './submission-grid.component.scss',
})
export class SubmissionGridComponent implements OnInit {
  submissionGridStore = inject(SubmissionGridStore);
  lookupStore = inject(LookupStore);
  authStore = inject(AuthStore);
  submissionGridOptions = inject(SubmissionGridOptions);
  inAppNotificationsService = inject(InAppNotificationsService);
  dialog = inject(MatDialog);
  defaultSortColumn = 'createDate';
  defaultSortDirection = 'DESCENDING';
  agencyId = signal<number | null | undefined>(this.authStore.user()?.agencyId ?? undefined);
  tenantId = signal<number | null | undefined>(null);
  gridOptions = signal<GridOptions>(
    this.authStore.isWholesale() ? this.submissionGridOptions.WholesalerOptions
    : this.authStore.isAdmin() ? this.submissionGridOptions.AdminOptions
    :  this.submissionGridOptions.OtherOptions
  );

  constructor(private router: Router) {
  }

  async ngOnInit(): Promise<void> {

    if (this.agencyId()) {
      this.lookupStore.loadLookup('agents', this.agencyId() ?? 0);
    }
    if (this.authStore.isWholesale()) {
      this.lookupStore.loadLookup('agencies');
    }
   
    if (this.authStore.isAdmin()) {
      this.lookupStore.loadLookup('tenants');
    }
    else{
       // Check for modal notification when wholesaler/retailer users visit the submission grid
      await this.checkForModalNotification();
    }
    this.lookupStore.loadLookup('submissionTypes');
    this.lookupStore.loadLookup('submissionStatuses');
    this.lookupStore.loadLookup('programs');
    this.lookupStore.loadLookup('states');
  }

  private async checkForModalNotification(): Promise<void> {
    try {
      const notification = await this.inAppNotificationsService.getModalNotification();
      if (notification && (notification.header || notification.body)) {
        this.dialog.open(InAppNotificationModalComponent, {
          data: notification,
          disableClose: false,
          panelClass: 'centered-wide-modal-panel-class'
        });
      }
    } catch (error) {
      console.error('Error checking for modal notification:', error);
    }
  }

  fetchAll(rawParams?: any) {
    const {sortOrder, agencyId, tenantId } = rawParams;
    //#region Update and load lookups
    if (this.authStore.isAdmin()) {
      if (!tenantId) {
        this.lookupStore.clearLookup('agencies');
        this.tenantId.set(null);
      } else if (tenantId && this.tenantId() !== tenantId) {
        this.tenantId.set(tenantId);
        this.lookupStore.loadLookup('agencies', tenantId);
      }
    }
    if (this.authStore.isWholesale() || this.authStore.isAdmin()) {
      if (!agencyId) {
        this.lookupStore.clearLookup('agents');
        this.agencyId.set(null);
      } else if (agencyId && this.agencyId() !== agencyId) {
        this.agencyId.set(agencyId);
        this.lookupStore.loadLookup('agents', agencyId);
      }
    }
    //#endregion
    const newSortOrder = this.sortField(sortOrder);
    const params = {
      ...rawParams,
        SortField: newSortOrder
          ? newSortOrder.active && newSortOrder.direction
            ? newSortOrder.active
            : this.defaultSortColumn
          : this.defaultSortColumn,
        SortDirection: newSortOrder ? newSortOrder.direction ?? this.defaultSortDirection : this.defaultSortDirection,
    }
    this.submissionGridStore.setFilterValues(params);
  }

  sortField(sort: Sort) {
    let activeSort: string = this.defaultSortColumn;
    let direction: string | null = this.defaultSortDirection;
    if (sort !== null && sort !== undefined) {
      activeSort = sort.active;
      switch (true) {
        case sort.direction === 'desc':
          direction = 'DESCENDING';
          break;
        case sort.direction === 'asc':
          direction = 'ASCENDING';
          break;
        case sort.direction === '':
          direction = null;
          break;
      }
    }
    return { active: activeSort, direction: direction };
  }

  actionEvent(event: GridEmitter) {
    if (event.action === 'fetchAll') {
      this.fetchAll(event.data);
    } else if (event.action === 'formChanges') {
      this.fetchAll(event.data);
    } else if (event.action === 'clearFilters') {
      this.fetchAll(event.data);
    } else if (event.action === 'onDestroy') {
      // on Destroy
    } else if (event.action === 'action') {
      this.router.navigate(['submissions/summary', (event.data as SubmissionGridRowViewModel)?.submissionGuid]);
    }
  }

  export() {
    console.log('export main button clicked');
  }
}
